import {cn} from './lib/utils';

interface LogoProps {
  href?: string;
  className?: string;
  inverted?: boolean;
  // When set, the full lockup is replaced by the icon-only mark on very narrow
  // screens (below 400px) so the header doesn't overflow.
  iconOnlyOnMobile?: boolean;
}

export function Logo({href, className, inverted = false, iconOnlyOnMobile = false}: LogoProps) {
  const img = (
    <>
      {iconOnlyOnMobile && (
        <img
          src='/img/logo_mini.svg'
          width={40}
          height={40}
          alt='Interview Query'
          className='block h-10 w-auto min-[400px]:hidden'
        />
      )}
      <img
        src={inverted ? '/img/logo_white.svg' : '/img/logo.svg'}
        width={139}
        height={40}
        alt='Interview Query'
        className={cn('h-10 w-auto', iconOnlyOnMobile ? 'hidden min-[400px]:block' : 'block')}
      />
    </>
  );

  return (
    <div className={cn('h-10', className)}>
      {href ? (
        <a href={href} className='block'>
          {img}
        </a>
      ) : (
        img
      )}
    </div>
  );
}
